<app-select-dropdown *ngIf="filtersList" [svg]='true' [borderless]='true' [list]="filtersList"
    (onSave)="hideDammageType()">
</app-select-dropdown>


// WEBPACK FOOTER //
// ./src/app/element/damage-analysis-filter/damage-analysis-filter.component.html